import type { NavigationConfig } from './NavigationBar';

/**
 * Pre-configured navigation configurations for common use cases
 */
export const NavigationConfigs = {
  // No navigation (for auth pages)
  none: (): NavigationConfig => ({
    show: false,
  }),

  // Restaurants page with logo, branding, and account dropdown
  restaurants: (): NavigationConfig => ({
    show: true,
    showLogo: true,
    showBranding: true,
    brandingText: 'Qodrix Menu',
    showAccountDropdown: true,
  }),

  // Menu pages with back button and current functionality
  menuBuilder: (
    restaurantName: string,
    onBack: () => void,
    rightContent?: React.ReactNode
  ): NavigationConfig => ({
    show: true,
    showBackButton: true,
    backButtonProps: {
      onClick: onBack,
      title: 'Back to Restaurants',
    },
    title: 'Menu Builder',
    subtitle: restaurantName,
    rightContent,
  }),

  // Image menu page
  imageMenu: (
    restaurantName: string,
    onBack: () => void,
    rightContent?: React.ReactNode
  ): NavigationConfig => ({
    show: true,
    showBackButton: true,
    backButtonProps: {
      onClick: onBack,
      title: 'Back to Restaurants',
    },
    title: 'Image Menu',
    subtitle: restaurantName,
    rightContent,
  }),

  // QR Code management page
  qrCodeManagement: (
    restaurantName: string,
    onBack: () => void,
    rightContent?: React.ReactNode
  ): NavigationConfig => ({
    show: true,
    showBackButton: true,
    backButtonProps: {
      onClick: onBack,
      title: 'Back to Restaurants',
    },
    title: 'QR Code Manager',
    subtitle: restaurantName,
    rightContent,
  }),

  // Menu item management (inside a section)
  menuItemList: (
    sectionName: string,
    restaurantName: string,
    onBack: () => void,
    rightContent?: React.ReactNode
  ): NavigationConfig => ({
    show: true,
    showBackButton: true,
    backButtonProps: {
      onClick: onBack,
      title: 'Back to Sections',
    },
    title: sectionName,
    subtitle: `${restaurantName} • Menu Items`,
    rightContent,
  }),

  // Add/Edit restaurant pages
  addRestaurant: (onBack: () => void): NavigationConfig => ({
    show: true,
    showBackButton: true,
    backButtonProps: {
      onClick: onBack,
      title: 'Back to Restaurants',
    },
    title: 'Add Restaurant',
  }),

  editRestaurant: (restaurantName: string, onBack: () => void): NavigationConfig => ({
    show: true,
    showBackButton: true,
    backButtonProps: {
      onClick: onBack,
      title: 'Back to Restaurants',
    },
    title: 'Edit Restaurant',
    subtitle: restaurantName,
  }),

  // Custom configuration builder
  custom: (config: Partial<NavigationConfig>): NavigationConfig => ({
    show: true,
    ...config,
  }),
};
